import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" onClick={scrollToTop} className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-ancient-gate-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-900">
                风车动漫
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              专注手机动漫的门户网站，为您提供最新动漫资讯、热门推荐和深度评测。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">
              <a href="#footer-categories" className="no-underline text-foreground-900">动漫分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={scrollToTop}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}动漫
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">
              <a href="#footer-more-categories" className="no-underline text-foreground-900">更多分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={scrollToTop}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}动漫
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-foreground-900 mb-4">
              <a href="#footer-links" className="no-underline text-foreground-900">关于我们</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                联系方式
              </Link>
              <Link to="/about" onClick={scrollToTop} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                用户口碑
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 风车动漫 FengCheDongMan. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}